export const AnalyticsTableColumns = {
    'all': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '110'
    }, {
        prop: 'operationBehavior',
        label: 'history.header.operation_behavior',
        type: 'operationBehavior',
        customRender: true
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        type: 'action',
        width: '120',
        customRender: true
    }],
    'search': [{
        prop: 'searchStrategy',
        label: 'history.header.search_strategy',
        customRender: true,
        type: 'query'
    }, {
        prop: 'searchRange',
        label: 'history.header.searchRange',
        width: '120',
        customRender: true,
        type: 'range',
        align: 'center'
    }, {
        prop: 'searchCreateAndUpdate',
        label: 'history.header.created_update_time',
        width: '220',
        customRender: true,
        type: 'dateLog'
    }, {
        prop: 'resultCount',
        label: 'history.header.resultCount',
        customRender: true,
        width: '130',
        type: 'count'
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        customRender: true,
        width: '120',
        type: 'action'
    }],
    'view': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '119'
    }, {
        prop: 'address',
        label: 'history.header.patent',
        type: 'operationBehavior',
        customRender: true
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        type: 'action',
        width: '120',
        customRender: true
    }],
    'analysis': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '110'
    }, {
        prop: 'address',
        label: 'history.header.search_strategy',
        type: 'operationBehavior',
        customRender: true
    }, {
        prop: 'label_type',
        label: 'history.header.analytics_type',
        type: 'analyticsType',
        width: '120',
        customerLabel: true
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        type: 'action',
        width: '120',
        customRender: true
    }],
    'export': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '110'
    }, {
        prop: 'address',
        label: 'history.header.search_strategy',
        type: 'operationBehavior',
        customRender: true
    }, {
        prop: 'contentField',
        label: 'history.header.content_field',
        type: 'contentField',
        customRender: true,
        width: '160'
    }, {
        prop: 'exportCount',
        label: 'history.header.formula_count',
        type: 'exportCount',
        width: '110',
        align: 'center'
    }, {
        prop: 'exportFormat',
        label: 'history.header.format',
        type: 'type',
        align: 'center',
        width: '150',
    }, {
        prop: 'result',
        label: 'history.header.download_status',
        type: 'status',
        width: '130',
        customRender: true
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        type: 'action',
        width: '120',
        customRender: true
    }],
    'file_wrapper': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '110'
    }, {
        prop: 'address',
        label: 'history.header.file_name',
        type: 'operationBehavior',
        customRender: true
    }, {
        prop: 'result',
        label: 'history.header.download_status',
        type: 'status',
        width: '130',
        customRender: true
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        type: 'action',
        width: '120',
        customRender: true
    }],
    'export_paper': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '110'
    }, {
        prop: 'address',
        label: 'history.header.search_strategy',
        type: 'operationBehavior',
        customRender: true
    }, {
        prop: 'contentField',
        label: 'history.header.content_field',
        type: 'contentField',
        customRender: true,
        width: '160'
    }, {
        prop: 'exportCount',
        label: 'history.header.formula_count',
        type: 'exportCount',
        width: '110',
        align: 'center'
    }, {
        prop: 'exportFormat',
        label: 'history.header.format',
        type: 'type',
        align: 'center',
        width: '150',
    }, {
        prop: 'result',
        label: 'history.header.download_status',
        type: 'status',
        width: '130',
        customRender: true
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        type: 'action',
        width: '120',
        customRender: true
    }]
};
export const DiscoveryTableColumns = {
    'search': [{
        prop: 'searchStrategy',
        label: 'history.header.search_strategy',
        customRender: true,
        type: 'query'
    }, {
        prop: 'label_type',
        label: 'history.header.data_type',
        type: 'dataType',
        width: '150',
        customerLabel: true
    }, {
        prop: 'updateTime',
        label: 'history.header.time',
        width: '220'
    }, {
        prop: 'resultCount',
        label: 'history.header.formula_count',
        width: '110',
        type: 'count',
        align: 'center'
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        customRender: true,
        width: '120',
        type: 'action'
    }],
    'export': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '120'
    }, {
        prop: 'searchStrategy',
        label: 'history.header.search_strategy',
        customRender: true,
        type: 'query'
    }, {
        prop: 'label_type',
        label: 'history.header.data_type',
        type: 'dataType',
        width: '150',
        customerLabel: true
    }, {
        prop: 'total',
        label: 'history.header.formula_count',
        width: '110',
        type: 'count',
        align: 'center',
        customerNumber: true
    }, {
        prop: 'status',
        label: 'history.header.download_status',
        width: '130',
        customRender: true,
        type: 'status'
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        customRender: true,
        width: '120',
        type: 'action'
    }]
};
export const ChemicalTableColumns = {
    'all': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '130'
    }, {
        prop: 'operationBehavior',
        label: 'history.header.operation_behavior',
        type: 'chemicalOperation',
        customRender: true
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        customRender: true,
        width: '120',
        type: 'action'
    }],
    'search': [{
        prop: 'operationBehavior',
        label: 'history.header.search_strategy',
        type: 'chemicalOperation',
        customRender: true
    }, {
        prop: 'updateTime',
        label: 'history.header.time',
        width: '220'
    }, {
        prop: 'resultCount',
        label: 'history.header.resultCount',
        width: '110',
        type: 'count',
        align: 'center'
    }, {
        prop: 'settings',
        label: 'history.header.settings',
        width: '60',
        type: 'chemicalSearchSetting',
        customRender: true
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        customRender: true,
        width: '120',
        type: 'action'
    }],
    'extracted_chemicals': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '130'
    }, {
        prop: 'chemicalFormula',
        label: 'history.header.chemical_formula',
        customRender: true,
        type: 'chemicalOperation'
    }, {
        prop: 'chemicalFormulaCount',
        label: 'history.header.formula_count',
        width: '110',
        type: 'count',
        align: 'center'
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        customRender: true,
        width: '120',
        type: 'action'
    }],
    'chemical_view': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '130'
    }, {
        prop: 'chemicalFormula',
        label: 'history.header.chemical_formula',
        customRender: true,
        type: 'chemicalOperation'
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        customRender: true,
        width: '120',
        type: 'action'
    }],
    'analysis': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '130'
    }, {
        prop: 'chemicalFormula',
        label: 'history.header.search_strategy',
        customRender: true,
        type: 'chemicalOperation'
    }, {
        prop: 'historySourceText',
        label: 'history.header.analytics_type',
        type: 'historySourcee',
        width: '130',
        customerLabel: true
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        customRender: true,
        width: '120',
        type: 'action'
    }],
    'export': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '130'
    }, {
        prop: 'searchStrategy',
        label: 'history.header.search_strategy',
        customRender: true,
        type: 'chemicalOperation'
    }, {
        prop: 'contentField',
        label: 'history.header.content_field',
        type: 'contentField',
        customRender: true,
        width: '200'
    }, {
        prop: 'resultCount',
        label: 'history.header.formula_count',
        type: 'formulaCount',
        width: '110',
        align: 'center'
    }, {
        prop: 'fileType',
        label: 'history.header.format',
        type: 'fileType',
        width: '150'
    }, {
        prop: 'status',
        label: 'history.header.download_status',
        width: '130',
        customRender: true,
        type: 'status'
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        customRender: true,
        width: '120',
        type: 'action'
    }]
};
export const LoginTableColumns = {
    'login': [{
        prop: 'time',
        label: 'history.header.time',
        type: 'time',
        width: '239'
    }, {
        prop: 'address',
        label: 'history.header.address',
        type: 'address',
        strongColor: true,
    }, {
        prop: 'message',
        label: 'history.header.message',
        type: 'message',
        width: '300'
    }, {
        prop: 'searchAction',
        label: 'history.historyQuery.action',
        type: 'action',
        width: '120',
        customRender: true
    }]
};
